import { atom } from 'jotai';

/**
 * Set of productGroupKeys that were recently moved via a repositioning action.
 * Used to trigger a highlight animation on the corresponding table rows.
 * Should be cleared after the animation duration (~2s).
 */
export const recentlyMovedGroupKeysState = atom<Set<string>>(new Set<string>());
